import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useGetQuestionsByFlowQuery } from "../../../../../store/api/useQuestion";
import { message } from "antd";
import CustomAlertModal from "./CustomAlertModal";
import InformationCircleIcon from "../../../../../assets/icons/img.png"; // Adjust the path if needed
import axios from "axios"; // Ensure axios is installed
import { useCreateAnswerMutation } from "../../../../../store/api/useAnswersApi";
import SavingsModal from "./SavingsModal"; // adjust path if needed
import RefundModal from "./RefundModal"; // adjust path if needed
import RefundAmountModal from "./RefundAmountModal"; // adjust path if needed
import AppInstallModal from "./AppInstallModal"; // adjust path if needed

// utils/xhrParamsBuilder.js

const QuestionsPage = () => {
  const { id: flowId } = useParams();
  const params = useParams();
  const [activeFlowId, setActiveFlowId] = useState(params.id);
  const [isPageVisible, setIsPageVisible] = useState(false);

  const navigate = useNavigate();
  const { data: questionsData, isLoading } =
    useGetQuestionsByFlowQuery(activeFlowId);
  const [showModal, setShowModal] = useState(false);
  const [createAnswer, { isLoading: isSubmitting }] = useCreateAnswerMutation();
  const token = localStorage.getItem("token"); // OR get from Redux if persisted
  const [step, setStep] = useState(1); // start at step 1
  const estimationId = localStorage.getItem("estimationId"); // or wherever you store the JWT
  const [localXhrParams, setLocalXhrParams] = useState({});
  const [annualSaving, setAnnualSaving] = useState(null);
  const [spendPerDay, setSpendPerDay] = useState(null);
  const [refund, setRefund] = useState(null);
  const [refundYears, setRefundYears] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [nextFlowId, setNextFlowId] = useState(null);
  const [isModalSavinglOpen, setIsModalSavinglOpen] = useState(false);
  const [isRefundModalOpen, setIsRefundModalOpen] = useState(false);
  const [isRefundAmountModalOpen, setIsRefundAmountModalOpen] = useState(false);
  const [isAppInstallModalOpen, setIsAppInstallModalOpen] = useState(false);

  const handleNavigateFlow = () => {
    if (nextFlowId) {
      setActiveFlowId(nextFlowId); // 👈 swap to new flow
      setStep(1);
      setCurrentQuestionId(null);
      setNextFlowId(null);
      setIsModalOpen(false);
      setIsModalSavinglOpen(false);
      setIsRefundModalOpen(false);
      setIsRefundAmountModalOpen(false);
    }
  };

  const handleRestartFlow = async () => {
    console.log(
      "🔍 handleRestartFlow called - creating new estimation and switching to savings flow"
    );

    try {
      // Create a new estimation (like the initial estimation)
      const payload = {
        startDate: new Date().toISOString(),
        user: "69382cdaa3888f1d63a5361d", // Replace with dynamic user id if available
        income: null,
        source: "Mobile app",
        status: "In progress",
        ownCar: null,
        mileage: null,
        mileageRate: null,
        foodAndDrink: null,
        daysPerWeek: null,
        reimbursedPerDay: null,
        annualSaving: null,
        trialStarted: null,
        refundYears: 0,
        refund: null,
        onBoardingStatut: null,
        timeSpent: 0,
        mileageType: 0,
        spendPerDay: 0,
        annualExpenses: 0,
      };

      // API call to create new estimation
      const response = await axios.post(
        "https://api.savyapp.dev/api/v1/estimations/user/me",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      console.log("🔍 New estimation created:", response.data);
      const newEstimationId = response.data.id;

      // Save the new estimation ID
      localStorage.setItem("estimationId", newEstimationId);

      // Switch to savings flow (the first flow)
      const savingsFlowId = "688a0e2564d03f7782f0910a"; // The savings flow ID
      setActiveFlowId(savingsFlowId);

      // Reset all state
      setStep(1);
      setCurrentQuestionId(null);
      setAnswers({});
      setLocalXhrParams({});
      setAnnualSaving(null);
      setSpendPerDay(null);
      setRefund(null);
      setRefundYears(null);
      setIsModalOpen(false);
      setNextFlowId(null);
      setIsModalSavinglOpen(false);
      setIsRefundModalOpen(false);
      setIsRefundAmountModalOpen(false);

      console.log("🔍 Switched to savings flow and reset all state");
    } catch (error) {
      console.error("🔍 Error creating new estimation:", error);
      // Fallback: just reset the current flow
      setStep(1);
      setCurrentQuestionId(null);
      setAnswers({});
      setLocalXhrParams({});
      setAnnualSaving(null);
      setSpendPerDay(null);
      setRefund(null);
      setRefundYears(null);
      setIsModalOpen(false);
      setNextFlowId(null);
      setIsModalSavinglOpen(false);
      setIsRefundModalOpen(false);
      setIsRefundAmountModalOpen(false);
    }
  };
  const [answers, setAnswers] = useState({});
  const [currentQuestionId, setCurrentQuestionId] = useState(null);

  useEffect(() => {
    if (questionsData && questionsData.length > 0) {
      setCurrentQuestionId(questionsData[0]._id);
      const initialAnswers = {};
      questionsData.forEach((q) => {
        initialAnswers[q._id] = "";
      });
      setAnswers(initialAnswers);
    }
  }, [questionsData]);

  useEffect(() => {
    // Fade in animation when page loads
    setTimeout(() => setIsPageVisible(true), 50);
  }, []);

  const handleChange = (questionId, option) => {
    setAnswers((prev) => {
      const currentAnswer = prev[questionId] || [];

      if (
        currentQuestion.type === "checkbox" ||
        currentQuestion.type === "grid_checkboxv2"
      ) {
        // Toggle option (add/remove)
        if (currentAnswer.includes(option)) {
          return {
            ...prev,
            [questionId]: currentAnswer.filter((o) => o !== option),
          };
        } else {
          return {
            ...prev,
            [questionId]: [...currentAnswer, option],
          };
        }
      } else {
        // Radio: single value
        return {
          ...prev,
          [questionId]: option,
        };
      }
    });
  };

  const patchEstimation = async (estimationId, payload) => {
    const token = localStorage.getItem("token"); // your JWT
    try {
      const response = await axios.patch(
        `https://api.savyapp.dev/api/v1/estimations/${estimationId}`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (err) {
      console.error("Failed to update estimation:", err);
    }
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setIsModalSavinglOpen(false);
    setIsRefundModalOpen(false);
    setIsRefundAmountModalOpen(false);
    setIsAppInstallModalOpen(false);
    // Optionally, go to the next question after closing
  };

  const handleNext = async () => {
    const currentQuestion = questionsData.find(
      (q) => q._id === currentQuestionId
    );
    if (!currentQuestion) return;

    const userAnswer = answers[currentQuestion._id];

    // Get the value (like 1, 2, 3) from xhrParams based on the chosen label
    let matchedInput;

    // For radio questions, find by label
    if (currentQuestion.type.startsWith("radio")) {
      matchedInput = currentQuestion.xhrParams?.inputs?.find(
        (i) => i.label === userAnswer
      );
    } else {
      // For numeric or free text, just take the first input
      matchedInput = currentQuestion.xhrParams?.inputs?.[0];
    }

    let computedValue;
    if (matchedInput?.value.includes("parseFloat")) {
      computedValue = parseFloat(userAnswer.replace(/,/g, ""));
    } else if (matchedInput?.value.includes("parseInt")) {
      computedValue = parseInt(userAnswer.replace(/,/g, ""), 10);
    } else {
      computedValue = matchedInput?.value;
    }

    const answerValue = computedValue;

    const xhrPayload = {};
    const validationTarget = currentQuestion.xhrParams?.validation?.target; // e.g. "income"

    // 1️⃣ Always store the main value based on validation target
    if (matchedInput) {
      //  xhrPayload['undefined'] = validationTarget;

      xhrPayload[validationTarget || "value"] = computedValue;
    }

    // 2️⃣ Check if this question has validation logic in handleNext
    const validationFromHandleNext = currentQuestion.handleNext?.find(
      (h) => h.action === "validation"
    );

    if (validationFromHandleNext?.validation) {
      // Save validation details into xhrPayload
      xhrPayload.validation = {
        type: validationFromHandleNext.validation.type || null,
        target: validationFromHandleNext.validation.target || null,
      };
    }

    // 3️⃣ If there is validation logic, check dynamic conditions
    if (validationFromHandleNext) {
      const dynNext = currentQuestion.dynamicHandleNext?.find((dyn) => {
        const { field, operator, target } = dyn.conditions || {};
        if (!operator || target === undefined) return false;
        const fieldValue = annualSaving;
        switch (operator) {
          case "==":
            return answerValue == target;

          case "!=":
            return answerValue != target;
          case ">":
            return Number(fieldValue) > Number(target);

          case "<":
            return Number(fieldValue) < Number(target);

          case ">=":
            return Number(fieldValue) >= Number(target);

          case "<=":
            return Number(fieldValue) <= Number(target);

          default:
            return false;
        }
      });

      // 4️⃣ If no dynamic condition matched, handle based on flow type
      if (dynNext) {
        const { field, operator, target } = dynNext.conditions;
      } else {
        // Check if current flow is "Refund" and show sorry modal instead of error
        const currentFlowTitle = currentQuestion?.flow?.title;
        if (currentFlowTitle === "Refund") {
          setIsRefundModalOpen(true);
          return;
        } else {
          message.error("❗ No matching dynamic condition found.");
          return;
        }
      }

      // 5️⃣ Submit the answer to API
      try {
        let finalAnswer = userAnswer;
        if (currentQuestion?.xhrParams?.validation?.type === "boolean") {
          if (typeof userAnswer === "string") {
            finalAnswer = userAnswer.toLowerCase() === "true";
          } else {
            finalAnswer = Boolean(userAnswer);
          }
        }
        console.log("🔍 Submitting answer:", {
          flowId: activeFlowId,
          ref: currentQuestion.ref,
          title: currentQuestion.title,
          value: finalAnswer,
          xhrParams: xhrPayload,
          userAnswer: userAnswer,
        });

        await createAnswer({
          flowId: activeFlowId,
          userId: localStorage.getItem("userId") || undefined,
          answers: [
            {
              ref: currentQuestion.ref,
              title: currentQuestion.title,
              value: finalAnswer,
            },
          ],
          xhrParams: xhrPayload,
          status: "in_progress",
        }).unwrap();

        if (estimationId) {
          let patchValue = computedValue;
          if (
            currentQuestion.ref === "5" &&
            answers["689c6c7b64d03f7782f0a4e8"]
          ) {
            patchValue = parseFloat(answers["689c6c7b64d03f7782f0a4e8"]);
          }
          // 🔥 If validation says it's a boolean, cast properly
          if (currentQuestion?.xhrParams?.validation?.type === "boolean") {
            let inputObj = currentQuestion?.xhrParams?.inputs?.find(
              (i) => i.label === userAnswer || i.value === userAnswer
            );

            let inputValue = inputObj?.value;

            // Update the outer patchValue
            patchValue =
              typeof inputValue === "string"
                ? inputValue.toLowerCase() === "true"
                : Boolean(inputValue);
          }

          if (currentQuestion?.xhrParams?.validation?.type === "listString") {
            // Normalize to array in case user selected only one answer
            const answersArray = Array.isArray(userAnswer)
              ? userAnswer
              : [userAnswer];

            // Map user selections to the "value" field
            patchValue = answersArray.map((ans) => {
              let inputObj = currentQuestion?.xhrParams?.inputs?.find(
                (i) => i.label === ans || i.value === ans || i._id === ans
              );
              return inputObj ? inputObj.value : ans; // must be value, not label
            });
          }

          if (currentQuestion?.xhrParams?.validation?.type === "list") {
            // Normalize to array in case user selected only one answer
            const answersArray = Array.isArray(userAnswer)
              ? userAnswer
              : [userAnswer];

            // Map labels/values back to the integer values from inputs
            patchValue = answersArray
              .map((ans) => {
                let inputObj = currentQuestion?.xhrParams?.inputs?.find(
                  (i) => i.label === ans || i.value === ans || i._id === ans
                );
                return inputObj ? parseInt(inputObj.value, 10) : null; // cast to int
              })
              .filter((v) => v !== null); // remove nulls if no match
          }

          let patchPayload = {
            [validationTarget]: patchValue,
          };

          // Special handling for refund years - check for ref "5" in refund flow
          if (
            (currentQuestion?.ref === "5" &&
              currentQuestion?.flow?.title === "Refund") ||
            validationTarget === "refundYears" ||
            currentQuestion?.ref === "13"
          ) {
            // This is the year selection question in refund flow
            if (Array.isArray(userAnswer)) {
              patchPayload.refundYears = userAnswer.length;
            } else if (typeof userAnswer === "string" && userAnswer) {
              // Count commas + 1 to get number of selected years
              patchPayload.refundYears = userAnswer.split(",").length;
            } else if (typeof userAnswer === "number") {
              // Direct number value
              patchPayload.refundYears = userAnswer;
            }
            console.log(
              "🔍 Setting refundYears (ref 5 refund flow):",
              patchPayload.refundYears
            );
            console.log("🔍 User answer:", userAnswer);
            console.log("🔍 Question ref:", currentQuestion?.ref);
            console.log("🔍 Flow title:", currentQuestion?.flow?.title);
          }
          if (currentQuestion?.ref === "5") {
            // Check if this is refund flow (year selection) or savings flow (mileage)
            if (currentQuestion?.flow?.title === "Refund") {
              // This is the year selection question in refund flow
              // The refundYears logic is already handled above
              console.log(
                "🔍 Refund flow ref 5 - year selection handled above"
              );
            } else {
              // This is the mileage expenses question in savings flow
              if (userAnswer === "No expenses") {
                patchPayload = { mileageType: 3, mileageRate: null };
              } else if (userAnswer === "Fuel card") {
                patchPayload = { mileageType: 2, mileageRate: 0 };
              } else {
                // Default: use API response values
                patchPayload = {
                  mileageType: 1,
                  mileageRate:
                    parseFloat(answers["689c6c7b64d03f7782f0a4e8"]) / 100,
                };
              }
            }
          }

          if (currentQuestion?.type === "grid_checkboxv2") {
            // Ensure array
            const answersArray = Array.isArray(userAnswer)
              ? userAnswer
              : [userAnswer];

            // Map to actual "value" from inputs if needed
            patchValue = answersArray.map((ans) => {
              let inputObj = currentQuestion?.xhrParams?.inputs?.find(
                (i) => i.label === ans || i.value === ans || i._id === ans
              );
              return inputObj ? inputObj.value : ans;
            });

            // ✅ Add length of selected choices
            patchPayload = {
              [validationTarget]: patchValue,
              selectedCount: patchValue.length, // <-- here's the count
            };

            // Special case: if this is the refund years question, set refundYears
            if (
              currentQuestion?.ref === "5" &&
              currentQuestion?.flow?.title === "Refund"
            ) {
              patchPayload.refundYears = patchValue.length;
              console.log(
                "🔍 Setting refundYears from grid_checkboxv2:",
                patchValue.length
              );
              console.log("🔍 Selected years:", patchValue);
            }
          }

          const updatedEstimation = await patchEstimation(
            estimationId,
            patchPayload
          );

          // Update your local state from the PATCH response
          console.log("🔍 Updated Estimation Response:", updatedEstimation);
          console.log("🔍 Refund value:", updatedEstimation.refund);
          console.log("🔍 RefundYears value:", updatedEstimation.refundYears);
          console.log("🔍 AnnualSaving value:", updatedEstimation.annualSaving);

          setAnnualSaving(updatedEstimation.annualSaving || 0);
          setSpendPerDay(updatedEstimation.spendPerDay || 0);
          setRefund(updatedEstimation.refund || 0);
          setRefundYears(updatedEstimation.refundYears || 0);
        }
      } catch (error) {
        console.error("Failed to submit answer:", error);
        message.error("Failed to submit answer. Please try again.");
        return;
      }

      if (dynNext.action === "navigate") {
        setNextFlowId(dynNext.nextQst); // save the target flowId

        // Check if current flow is "Refund" and show appropriate modal
        const currentFlowTitle = currentQuestion?.flow?.title;
        if (currentFlowTitle === "Refund") {
          // Check if we have refund data and should show refund amount modal
          if (refund && refundYears) {
            setIsRefundAmountModalOpen(true);
          } else {
            setIsRefundModalOpen(true);
          }
        } else {
          setIsModalOpen(true);
        }
      } else if (dynNext.action === "open_question") {
        const nextQuestion = questionsData.find(
          (q) => q.ref === dynNext.nextQst
        );
        if (nextQuestion) {
          setStep((prev) => prev + 1); // ✅ Increment here too

          setCurrentQuestionId(nextQuestion._id);
        } else {
          message.error("⚠️ Next question not found.");
        }
      }
      return;
    }

    // If no validation/dynamicHandleNext, fallback to original next handling
    const nextHandle = currentQuestion.handleNext?.[0];
    let nextQuestion = null;

    if (nextHandle?.action === "open_question") {
      nextQuestion = questionsData.find((q) => q.ref === nextHandle.nextQst);
    }
    if (matchedInput?.value === "1") xhrPayload.status = "Completed";
    if (matchedInput?.value === "2" || matchedInput?.value === "3")
      xhrPayload.status = "In progress";

    const isLastQuestion = !nextQuestion;

    const answerPayload = {
      flowId: activeFlowId,
      userId: localStorage.getItem("userId") || undefined,
      answers: [
        {
          ref: currentQuestion.ref,
          title: currentQuestion.title,
          value: userAnswer,
        },
      ],
      xhrParams: xhrPayload,
      status: isLastQuestion ? "completed" : "in_progress",
    };

    try {
      console.log("🔍 Submitting fallback answer:", answerPayload);
      await createAnswer(answerPayload).unwrap();
      if (estimationId) {
        let patchValue = computedValue;
        if (
          currentQuestion.ref === "5" &&
          answers["689c6c7b64d03f7782f0a4e8"]
        ) {
          patchValue = parseFloat(answers["689c6c7b64d03f7782f0a4e8"]);
        }
        // 🔥 If validation says it's a boolean, cast properly
        if (currentQuestion?.xhrParams?.validation?.type === "boolean") {
          let inputObj = currentQuestion?.xhrParams?.inputs?.find(
            (i) => i.label === userAnswer || i.value === userAnswer
          );

          let inputValue = inputObj?.value;

          // Update the outer patchValue
          patchValue =
            typeof inputValue === "string"
              ? inputValue.toLowerCase() === "true"
              : Boolean(inputValue);
        }

        if (currentQuestion?.xhrParams?.validation?.type === "listString") {
          // Normalize to array in case user selected only one answer
          const answersArray = Array.isArray(userAnswer)
            ? userAnswer
            : [userAnswer];

          // Map user selections to the "value" field
          patchValue = answersArray.map((ans) => {
            let inputObj = currentQuestion?.xhrParams?.inputs?.find(
              (i) => i.label === ans || i.value === ans || i._id === ans
            );
            return inputObj ? inputObj.value : ans; // must be value, not label
          });
        }

        if (currentQuestion?.xhrParams?.validation?.type === "list") {
          // Normalize to array in case user selected only one answer
          const answersArray = Array.isArray(userAnswer)
            ? userAnswer
            : [userAnswer];

          // Map labels/values back to the integer values from inputs
          patchValue = answersArray
            .map((ans) => {
              let inputObj = currentQuestion?.xhrParams?.inputs?.find(
                (i) => i.label === ans || i.value === ans || i._id === ans
              );
              return inputObj ? parseInt(inputObj.value, 10) : null; // cast to int
            })
            .filter((v) => v !== null); // remove nulls if no match
        }

        let patchPayload = {
          [validationTarget]: patchValue,
        };

        // Special handling for refund years - check for ref "5" in refund flow
        if (
          (currentQuestion?.ref === "5" &&
            currentQuestion?.flow?.title === "Refund") ||
          currentQuestion?.ref === "13" ||
          validationTarget === "refundYears"
        ) {
          // This is the year selection question
          if (Array.isArray(userAnswer)) {
            patchPayload.refundYears = userAnswer.length;
          } else if (typeof userAnswer === "string" && userAnswer) {
            // Count commas + 1 to get number of selected years
            patchPayload.refundYears = userAnswer.split(",").length;
          } else if (typeof userAnswer === "number") {
            // Direct number value
            patchPayload.refundYears = userAnswer;
          }
          console.log(
            "🔍 Setting refundYears (fallback - ref 5 refund):",
            patchPayload.refundYears
          );
          console.log("🔍 User answer (fallback):", userAnswer);
          console.log("🔍 Question ref (fallback):", currentQuestion?.ref);
          console.log(
            "🔍 Flow title (fallback):",
            currentQuestion?.flow?.title
          );
        }

        if (currentQuestion?.ref === "5") {
          // Example: map user answer into { mileageType, mileageRate }
          if (userAnswer === "No expenses") {
            patchPayload = { mileageType: 3, mileageRate: null };
          } else if (userAnswer === "Fuel card") {
            patchPayload = { mileageType: 2, mileageRate: 0 };
          } else {
            // Default: use API response values
            patchPayload = {
              mileageType: 1,
              mileageRate:
                parseFloat(answers["689c6c7b64d03f7782f0a4e8"]) / 100,
            };
          }
        }

        // Handle grid_checkboxv2 in fallback section
        if (currentQuestion?.type === "grid_checkboxv2") {
          // Ensure array
          const answersArray = Array.isArray(userAnswer)
            ? userAnswer
            : [userAnswer];

          // Map to actual "value" from inputs if needed
          patchValue = answersArray.map((ans) => {
            let inputObj = currentQuestion?.xhrParams?.inputs?.find(
              (i) => i.label === ans || i.value === ans || i._id === ans
            );
            return inputObj ? inputObj.value : ans;
          });

          // ✅ Add length of selected choices
          patchPayload = {
            [validationTarget]: patchValue,
            selectedCount: patchValue.length, // <-- here's the count
          };

          // Special case: if this is the refund years question, set refundYears
          if (
            currentQuestion?.ref === "5" &&
            currentQuestion?.flow?.title === "Refund"
          ) {
            patchPayload.refundYears = patchValue.length;
            console.log(
              "🔍 Setting refundYears from grid_checkboxv2 (fallback):",
              patchValue.length
            );
            console.log("🔍 Selected years (fallback):", patchValue);
          }
        }

        const updatedEstimation = await patchEstimation(
          estimationId,
          patchPayload
        );

        // Update your local state from the PATCH response
        console.log(
          "🔍 Updated Estimation Response (fallback):",
          updatedEstimation
        );
        console.log("🔍 Refund value (fallback):", updatedEstimation.refund);
        console.log(
          "🔍 RefundYears value (fallback):",
          updatedEstimation.refundYears
        );
        console.log(
          "🔍 AnnualSaving value (fallback):",
          updatedEstimation.annualSaving
        );

        setAnnualSaving(updatedEstimation.annualSaving || 0);
        setSpendPerDay(updatedEstimation.spendPerDay || 0);
        setRefund(updatedEstimation.refund || 0);
        setRefundYears(updatedEstimation.refundYears || 0);
      }
      if (nextQuestion) {
        setStep((prev) => prev + 1); // ✅ Increment here too

        setCurrentQuestionId(nextQuestion._id);
      } else {
        // Check if current flow is "Refund" and show appropriate modal
        const currentFlowTitle = currentQuestion?.flow?.title;
        if (currentFlowTitle === "Refund") {
          setIsRefundAmountModalOpen(true);
        } else {
          setIsModalSavinglOpen(true);
        }
        setNextFlowId(nextHandle?.nextQst); // save the target flowId
      }
    } catch (error) {
      console.error("Failed to submit answer:", error);
      message.error("Failed to submit answer. Please try again.", error);
    }
  };

  if (isLoading || !currentQuestionId) {
    return (
      <div className="flex justify-center items-center h-screen">
        Loading questions...
      </div>
    );
  }
  const currentQuestion = questionsData.find(
    (q) => q._id === currentQuestionId
  );

  const progressValues = questionsData.map((q) => q.progress);
  const totalSteps = Math.max(...progressValues) + 1;
  const stepIndex = currentQuestion?.progress ?? 0;
  const progressPercent = ((stepIndex + 1) / totalSteps) * 100;
  return (
    <>
      <div
        className={`h-full flex flex-col w-full transition-all duration-500 ease-out ${
          isPageVisible
            ? "opacity-100 translate-y-0"
            : "opacity-0 translate-y-4"
        }`}
        style={{
          paddingTop: "env(safe-area-inset-top)",
          paddingBottom: "calc(env(safe-area-inset-bottom) + 20px)",
        }}
      >
        {/* Main Content Area */}
        <div className="flex-1 flex flex-col max-w-3xl mx-auto w-full px-4 sm:px-6 md:px-8 py-4 sm:py-5 md:py-6 min-h-0 overflow-hidden">
          {currentQuestion && (
            <div className="bg-white shadow-xl rounded-xl flex flex-col h-full min-h-0 overflow-hidden">
              {/* Progress Bar at Top of Card */}
              <div className="w-full h-1.5 sm:h-2 bg-gray-100 rounded-t-xl overflow-hidden">
                <div
                  className="h-full bg-gradient-to-r from-[#8AB9F1] via-[#b57edc] to-[#F08080] transition-all duration-700 ease-out shadow-sm"
                  style={{ width: `${progressPercent}%` }}
                >
                  <div className="h-full w-full bg-gradient-to-r from-transparent via-white/20 to-transparent animate-pulse"></div>
                </div>
              </div>

              {/* Top Bar - Back, Title, Step */}
              <div className="flex justify-between items-center px-4 sm:px-6 md:px-10 pt-4 sm:pt-5 md:pt-6 pb-3 gap-2">
                {/* Back Button */}
                <button
                  className="text-xs sm:text-sm text-blue-500 hover:text-blue-600 hover:underline disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap font-medium transition-colors"
                  onClick={() => {
                    console.log("Back button clicked");
                    console.log("Current question ID:", currentQuestionId);
                    console.log("Questions data:", questionsData);

                    const current = questionsData.find(
                      (q) => q._id === currentQuestionId
                    );
                    console.log("Current question:", current);

                    if (!current) {
                      console.log("No current question found");
                      return;
                    }

                    // Get all progress values and sort them
                    const allProgressValues = questionsData
                      .map((q) => q.progress)
                      .sort((a, b) => a - b);

                    console.log("All progress values:", allProgressValues);
                    console.log("Current progress:", current.progress);

                    // Find the previous progress value that's less than current
                    const currentProgressIndex = allProgressValues.indexOf(
                      current.progress
                    );
                    const previousProgressValue =
                      currentProgressIndex > 0
                        ? allProgressValues[currentProgressIndex - 1]
                        : null;

                    console.log(
                      "Previous progress value:",
                      previousProgressValue
                    );

                    if (previousProgressValue !== null) {
                      const previousQuestion = questionsData.find(
                        (q) => q.progress === previousProgressValue
                      );
                      console.log("Previous question found:", previousQuestion);

                      if (previousQuestion) {
                        setStep((prev) => prev - 1);
                        setCurrentQuestionId(previousQuestion._id);
                        console.log(
                          "Navigated to previous question:",
                          previousQuestion._id
                        );
                      } else {
                        console.log(
                          "No previous question found with progress:",
                          previousProgressValue
                        );
                      }
                    } else {
                      console.log(
                        "No previous progress value found - already at first question"
                      );
                    }
                  }}
                  disabled={
                    !currentQuestion ||
                    (questionsData &&
                      questionsData.length > 0 &&
                      questionsData
                        .map((q) => q.progress)
                        .sort((a, b) => a - b)[0] === currentQuestion.progress)
                  }
                >
                  &larr; Back
                </button>

                {/* Title */}
                <h2 className="text-sm sm:text-base md:text-lg font-semibold text-center flex-1 px-2 text-gray-900">
                  Savings calculator
                </h2>

                {/* Step */}
                <span className="text-xs sm:text-sm text-gray-600 text-right whitespace-nowrap font-medium">
                  Step {step}
                </span>
              </div>

              {/* Question Content - Scrollable */}
              <div className="flex-1 flex flex-col min-h-0 overflow-y-auto px-4 sm:px-6 md:px-10 py-4">
                {/* Question Content */}
                <div className="flex-1 flex flex-col justify-center">
                  <h3 className="text-base sm:text-lg md:text-xl font-normal mb-4 sm:mb-6 leading-relaxed">
                    {currentQuestion.ref === "12"
                      ? currentQuestion.title.replace(
                          /\$\{data\?.spendPerDay\}/g,
                          spendPerDay || "0"
                        )
                      : currentQuestion.title}
                  </h3>

                  {(currentQuestion.type === "radio" ||
                    currentQuestion.type === "checkbox") && (
                    <div className="space-y-2 sm:space-y-3">
                      {currentQuestion.options.map((option) => (
                        <label
                          key={option}
                          className="flex items-center p-2 sm:p-3 rounded-lg cursor-pointer space-x-2 sm:space-x-3 hover:bg-gray-50 transition-colors"
                        >
                          <input
                            type={currentQuestion.type}
                            className="hidden peer"
                            value={option}
                            checked={answers[currentQuestion._id] === option}
                            onChange={() =>
                              handleChange(currentQuestion._id, option)
                            }
                          />
                          {/* Outer Circle becomes black when selected */}
                          <div className="w-4 h-4 sm:w-5 sm:h-5 border-2 rounded-full peer-checked:bg-black border-gray-400 transition-colors duration-200 flex-shrink-0"></div>
                          <span className="text-sm sm:text-base">{option}</span>
                        </label>
                      ))}
                    </div>
                  )}

                  {(currentQuestion.type === "radiov2" ||
                    currentQuestion.type === "grid_checkboxv2") && (
                    <div
                      className={`grid gap-3 sm:gap-4 ${
                        currentQuestion.options.length === 2
                          ? "grid-cols-2"
                          : "grid-cols-1 sm:grid-cols-2 md:grid-cols-3"
                      }`}
                    >
                      {currentQuestion.options.map((option) => {
                        const isSelected =
                          currentQuestion.type === "grid_checkboxv2"
                            ? answers[currentQuestion._id]?.includes(option)
                            : answers[currentQuestion._id] === option;
                        return (
                          <div
                            key={option}
                            className="flex flex-col gap-2"
                          >
                            {/* Radio Option */}
                            <div
                              onClick={() =>
                                handleChange(currentQuestion._id, option)
                              }
                              className={`relative cursor-pointer rounded-xl overflow-hidden transition ${
                                isSelected ? "" : "border border-gray-300"
                              }`}
                            >
                              {isSelected && (
                                <div className="absolute inset-0 custom-gradient" />
                              )}
                              <div
                                className={`relative z-10 rounded-xl py-3 sm:py-4 text-center bg-white text-black text-sm sm:text-base`}
                                style={{
                                  border: isSelected
                                    ? "2px solid transparent"
                                    : "",
                                  backgroundClip: isSelected
                                    ? "padding-box"
                                    : "",
                                }}
                              >
                                {option}
                              </div>
                            </div>

                            {/* Extra Numeric Input for Mileage rate */}
                            {isSelected && option === "Mileage rate" && (
                              <div className="relative w-full mt-4 sm:mt-6">
                                <div className="relative">
                                  {/* Wrapper */}
                                  <div className="flex items-center w-full border border-gray-300 rounded-md focus-within:ring-2 focus-within:ring-blue-500 focus-within:border-transparent transition">
                                    <input
                                      type="number"
                                      id="input-689c6c7b64d03f7782f0a4e8"
                                      placeholder=" "
                                      className="peer flex-1 bg-white pl-4 sm:pl-6 pt-3 sm:pt-4 pb-1 sm:pb-2 text-gray-900 rounded-md focus:outline-none text-sm sm:text-base"
                                      value={
                                        answers["689c6c7b64d03f7782f0a4e8"] ||
                                        ""
                                      }
                                      onChange={(e) =>
                                        handleChange(
                                          "689c6c7b64d03f7782f0a4e8",
                                          e.target.value
                                        )
                                      }
                                    />
                                  </div>

                                  {/* Floating Label */}
                                  <label
                                    htmlFor="input-689c6c7b64d03f7782f0a4e8"
                                    className="absolute left-3 sm:left-4 -top-2.5 bg-white px-1 text-gray-500 text-xs sm:text-sm pointer-events-none"
                                  >
                                    Rate
                                  </label>
                                </div>
                              </div>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  )}

                  {["input", "email", "price", "numeric", "counter"].includes(
                    currentQuestion.type
                  ) && (
                    <div className="relative w-full mt-4 sm:mt-6">
                      <div className="relative">
                        {/* Wrapper with flex if price */}
                        <div
                          className={`flex items-center w-full border border-gray-300 rounded-md focus-within:ring-2 focus-within:ring-blue-500 focus-within:border-transparent transition ${
                            currentQuestion.type === "price" ? "" : "block"
                          }`}
                        >
                          {/* Price Prefix if type is 'price' */}
                          {currentQuestion.type === "price" && (
                            <span className="pl-3 sm:pl-4 pt-2 sm:pt-3 text-gray-700 text-sm sm:text-base">
                              £
                            </span>
                          )}

                          <input
                            type={
                              currentQuestion.type === "email"
                                ? "email"
                                : "text"
                            }
                            id={`input-${currentQuestion._id}`}
                            placeholder=" "
                            className={`peer flex-1 bg-white ${
                              currentQuestion.type === "price"
                                ? "pl-2"
                                : "pl-3 sm:pl-4"
                            } pt-3 sm:pt-4 pb-1 sm:pb-2 text-gray-900 rounded-md focus:outline-none text-sm sm:text-base`}
                            value={answers[currentQuestion._id]}
                            onChange={(e) =>
                              handleChange(currentQuestion._id, e.target.value)
                            }
                          />
                        </div>

                        {/* Floating Label */}
                        <label
                          htmlFor={`input-${currentQuestion._id}`}
                          className="absolute left-3 sm:left-4 -top-2.5 bg-white px-1 text-gray-500 text-xs sm:text-sm pointer-events-none"
                        >
                          {currentQuestion.name}
                        </label>

                        {/* Character Counter */}
                      </div>
                    </div>
                  )}

                  {/* Info Banner */}
                  {currentQuestion.info && (
                    <div
                      className="mt-4 sm:mt-6 bg-[#edf3fd] text-sm text-gray-700 rounded-lg p-3 sm:p-4 flex items-start space-x-2 sm:space-x-3 border-l border-blue-300"
                      style={{ borderLeftWidth: "12px" }}
                    >
                      <img
                        src={InformationCircleIcon}
                        alt="info icon"
                        className="w-4 h-4 sm:w-5 sm:h-5 flex-shrink-0 mt-0.5"
                      />
                      <div className="flex-1">
                        <strong className="block mb-1 sm:mb-2 text-gray-900 font-medium text-sm sm:text-base">
                          {currentQuestion.infoTitle}
                        </strong>
                        <span className="text-xs sm:text-sm text-gray-600 leading-relaxed">
                          {currentQuestion.info}
                        </span>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              {/* Button Inside Card Footer */}
              <div
                className="px-4 sm:px-6 md:px-10 pt-4 sm:pt-5 md:pt-6 pb-4 sm:pb-5 md:pb-6 border-t border-gray-100 flex-shrink-0"
                style={{
                  paddingBottom: "calc(env(safe-area-inset-bottom) + 16px)",
                }}
              >
                <button
                  className="bg-[#002147] text-white py-3 sm:py-3.5 md:py-4 px-6 sm:px-12 md:px-16 lg:px-24 rounded-lg font-semibold hover:bg-[#003366] transition-all duration-200 block mx-auto w-full sm:w-auto min-w-[200px] sm:min-w-[280px] shadow-lg hover:shadow-xl transform hover:scale-[1.02] active:scale-[0.98] relative overflow-hidden disabled:bg-gray-400 disabled:cursor-not-allowed disabled:hover:scale-100 disabled:hover:shadow-lg disabled:hover:bg-gray-400"
                  onClick={(e) => {
                    if (!answers[currentQuestion?._id]) return;

                    // Add ripple effect
                    const button = e.currentTarget;
                    const ripple = document.createElement("span");
                    const rect = button.getBoundingClientRect();
                    const size = Math.max(rect.width, rect.height);
                    const x = e.clientX - rect.left - size / 2;
                    const y = e.clientY - rect.top - size / 2;

                    ripple.style.width = ripple.style.height = `${size}px`;
                    ripple.style.left = `${x}px`;
                    ripple.style.top = `${y}px`;
                    ripple.classList.add("ripple");

                    button.appendChild(ripple);
                    setTimeout(() => ripple.remove(), 600);

                    handleNext();
                  }}
                  disabled={!answers[currentQuestion?._id]}
                >
                  <span className="relative z-10">Next →</span>
                </button>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Modals */}
      <CustomAlertModal
        isOpen={isModalOpen}
        onClose={closeModal}
        onNavigate={handleNavigateFlow}
      />

      <SavingsModal
        isOpen={isModalSavinglOpen}
        onClose={closeModal}
        amount={annualSaving}
        onNavigate={handleNavigateFlow}
      />

      <RefundModal
        isOpen={isRefundModalOpen}
        onClose={closeModal}
        annualSaving={annualSaving}
        onNavigate={handleNavigateFlow}
        onRestartFlow={handleRestartFlow}
      />

      <RefundAmountModal
        isOpen={isRefundAmountModalOpen}
        onClose={closeModal}
        refund={refund}
        annualSaving={annualSaving}
        refundYears={refundYears}
        onNavigate={() => {
          setIsRefundAmountModalOpen(false);
          setTimeout(() => setIsAppInstallModalOpen(true), 300);
        }}
      />

      <AppInstallModal
        isOpen={isAppInstallModalOpen}
        onClose={() => setIsAppInstallModalOpen(false)}
      />
    </>
  );
};

export default QuestionsPage;
